import { MenuItem, alpha, styled } from "@mui/material";
import { NavLink } from "react-router-dom-v5-compat";
export const NavDrawerMenuItem = styled(MenuItem, {
    shouldForwardProp: (prop) => !["isNavDrawerMenuTrigger"].includes(prop), // Cast `prop` to string
})(({ theme, isNavDrawerMenuTrigger }) => ({
    padding: `${theme.spacing(1.5)} ${theme.spacing(3.75)}`,
    color: theme.palette.grey[`A700`],
    "&.Mui-selected": {
        padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
        borderLeft: !isNavDrawerMenuTrigger && `${theme.spacing(0.75)} solid ${theme.palette.primary.main}`,
    },
    "&:hover": {
        backgroundColor: alpha(theme.palette.primary.light, 0.1),
    },
    "&.is-nav-drawer-logout": {
        display: "flex",
        marginTop: "auto",
        position: "absolute",
        bottom: 0,
        width: "100%",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    "&.is-nav-menu-logout": {
        marginTop: theme.spacing(0.5),
        display: "flex",
        width: "100%",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    "&.is-selected": {
        color: theme.palette.common.black,
    },
}));
/**
 * Sets the default props. DO NOT CHANGE.
 * If additional customizations are required, creating a new styled component is likely the better approach.
 */
NavDrawerMenuItem.defaultProps = {
    component: NavLink, // The typography component will use the React-Router Nav Link component as it's base.
};
